// import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import logo from "../assets/logo.png";
// import styles from "./Navbar.module.css";
// import { useNavigate, useLocation } from "react-router-dom";
// import { FaHome } from "react-icons/fa";
// import { HiOutlineLogout } from "react-icons/hi";
// import Cookies from "js-cookie";

// const CustomNavbar = () => {
//   const [isMobile, setIsMobile] = useState(false);
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [activeLink, setActiveLink] = useState("");
//   const nav = useNavigate();
//   const location = useLocation();

//   // Fetch phone number from cookies
//   useEffect(() => {
//     const phoneNo = Cookies.get('adminPhoneNo');
//     if (phoneNo) {
//       setPhoneNumber(phoneNo);
//     }
//   }, []);

//   // Handle window resize for mobile view
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 767);
//     };
//     window.addEventListener("resize", handleResize);
//     handleResize(); // Initial check
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   // Set active link based on current path
//   useEffect(() => {
//     setActiveLink(location.pathname);
//   }, [location]);

//   // Logout handler
//   const handleLogout = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/logoutLender`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "X-Full-URL": window.location.href,
//         },
//         credentials: "include",
//         body: JSON.stringify({ number: phoneNumber }),
//       });

//       if (response.ok) {
//         // Clear all cookies
//         Cookies.remove("adminJwtToken");
//         Cookies.remove("adminRefreshToken");
//         Cookies.remove("adminPhoneNo");
//         Cookies.remove("adminAuthStatus");
//         Cookies.remove("adminUserType");
//         Cookies.remove("adminCommunityNO");
//         Cookies.remove("adminLenderInfo");
//         Cookies.remove("adminLocation");
//         Cookies.remove("adminSellerId");
//       }
//     } catch (error) {
//       console.error("Logout failed:", error);
//     } finally {
//       nav("/"); // Redirect to login after logout
//     }
//   };

//   // Navigation handler
//   const handleNavigation = (path) => {
//     nav(path);
//   };

//   return (
//     <nav className={styles.navbar}>
//       <div className="container-fluid bg-white">
//         {/* Logo */}
//         <div
//           className="navbar-brand"
//           onClick={() => handleNavigation("/dashboard")}
//           style={{ cursor: 'pointer' }}
//         >
//           <img src={logo} alt="Company Logo" className={styles.logoImg} />
//         </div>

//         {/* Mobile Toggle Button */}
//         <button
//           className={`navbar-toggler px-2 py-1 ${styles.navbarToggler}`}
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarNav"
//           aria-controls="navbarNav"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <span className={`navbar-toggler-icon ${styles.navbarTogglerIcon}`}></span>
//         </button>

//         {/* Navbar Links */}
//         <div className="collapse navbar-collapse" id="navbarNav">
//           <ul className="navbar-nav ms-auto">
//             {/* Home Link */}
//             <li className="nav-item">
//               <div
//                 className={`${styles.navLink} ${activeLink === "/dashboard" ? styles.navLinkActive : ""}`}
//                 onClick={() => handleNavigation("/dashboard")}
//                 style={{ fontWeight: "bold" }}
//               >
//                 <FaHome className={styles.navIcon} /> Home
//               </div>
//             </li>

//             {/* Logout Link */}
//             <li className="nav-item ms-2">
//               <div
//                 className={styles.navLink}
//                 onClick={handleLogout}
//                 style={{ fontWeight: "bold", color: "#ee373b" }}
//               >
//                 Logout <HiOutlineLogout className={styles.navIcon} />
//               </div>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default CustomNavbar;


//======================================================

import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; 
import logo from "../assets/logo.png";
import "./Navbar.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { FaUser, FaHome } from "react-icons/fa";
import { HiOutlineLogout } from "react-icons/hi";
import Cookies from "js-cookie";

const CustomNavbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const nav = useNavigate();
  const location = useLocation();
  const [userType, setUserType] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [activeLink, setActiveLink] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const userType = Cookies.get('adminUserType');
      const phoneNo = Cookies.get('adminPhoneNo');
      setPhoneNumber(phoneNo);

      if (userType !== undefined) {
        setUserType(userType);
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); 

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location]);

  const handleLogout = async () => {
    const URI = "logoutLender";
    const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/${URI}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Full-URL": window.location.href, 
      },
      credentials:"include",
      body: JSON.stringify({ number: phoneNumber }),
    });
    if (response.ok) {
        Cookies.remove("adminJwtToken");
        Cookies.remove("adminRefreshToken");
        Cookies.remove("adminPhoneNo");
        Cookies.remove("adminAuthStatus");
        Cookies.remove("adminUserType");
        Cookies.remove("adminCommunityNO");
        Cookies.remove("adminLenderInfo");
    }
    nav("/");
  };

  const handleNavigation = (path) => {
    nav(path);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white p-2" style={{ boxShadow: "2px 2px 7px rgb(147, 147, 147)", zIndex: "9999" }}>
      <div className="container-fluid">
        <div
          className="navbar-brand"
          onClick={() => {
            handleNavigation("/dashboard");
          }}
          style={{ cursor: 'pointer' }}
        >
          <img src={logo} alt="Company Logo" width="112" className="logo-img" />
        </div>

        {/* Toggle Button for Mobile */}
        <button
          className="navbar-toggler px-2 py-1"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links for Desktop */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto d-flex justify-content-end">
            {userType !== "Master_Lender" && <li className="nav-item">
              <div
                className={`nav-link ${activeLink === "/dashboard" ? "active" : ""}`}
                onClick={() => { nav("/dashboard"); }}
                style={{ cursor: 'pointer', fontWeight: "bold" }}
              >
                <FaHome className="nav-icon" /> Home
              </div>
            </li>}

            <li className="nav-item ms-2">
              <div
                className="nav-link"
                onClick={handleLogout}
                style={{ cursor: 'pointer', fontWeight: "bold", color: "#ee373b" }}
              >
                Logout <HiOutlineLogout className="nav-icon" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default CustomNavbar;
